import Services from './base-services'

const service = new Services('bookaudio')

export default {
  getVoices(bookId: number, page: number) {
    return service.contentGet(`voices/${bookId}/${page}`)
  },
  generateQuestionAudio(text: string) {
    return service.contentPost('generate_audio', { text })
  },
}
